import PropTypes from 'prop-types'
import React from 'react'

import SocialButton from './SocialButton'

function getShareLinks (url, text) {
  const encodedText = encodeURIComponent(text)
  const encodedUrl = encodeURIComponent(url)
  // links from: https://github.com/mxstbr/sharingbuttons.io/blob/master/js/stores/AppStore.js
  return {
    facebook: 'https://facebook.com/sharer/sharer.php?u=' + encodedUrl,
    twitter: `https://twitter.com/intent/tweet/?url=${encodedUrl}&text=${encodedText} via @snips`,
    linkedin:
      'https://www.linkedin.com/shareArticle?mini=true&url=' +
      encodedUrl +
      '&title=' +
      encodedText +
      '&summary=' +
      encodedText,
    email: `mailto:?subject=${encodedText}&body=${encodedUrl}`
  }
}

function getShareLink (url, text, network) {
  const shareLinks = getShareLinks(url, text)
  const shareLink = shareLinks[network]
  if (!shareLink) {
    console.log('not supporting network for social sharing:', network)
    return null
  }
  return shareLink
}

const SocialShareButtons = ({ url, text, networks, analyticsExtra }) => (
  <div className='social-share-buttons'>
    {networks.map(network => {
      const shareLink = getShareLink(url, text, network)
      if (!shareLink) return null
      return (
        <SocialButton
          key={network}
          url={shareLink}
          shareText={text}
          icon={network}
          forceAnchorElement={network === 'email'}
          target={network === 'email' ? undefined : '_blank'}
          analyticsExtra={analyticsExtra}
        />
      )
    })}
  </div>
)

SocialShareButtons.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  networks: PropTypes.array.isRequired,
  // passed along to SocialButton component
  analyticsExtra: PropTypes.string
}

SocialShareButtons.defaultProps = {
  networks: ['facebook', 'twitter', 'linkedin']
}

export default SocialShareButtons



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/SocialShareButtons.js